import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from '@gatsbyjs/reach-router';
import { SLink } from './styles';
import { camelCase, startCase } from 'lodash';

const Breadcrumbs = ({ title, isBlog = false }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace(/\/$/, '');
  const breadcrumbItems = currentPath.split('/');

  const getBreadcrumbName = (value, array, idx, title) => {
    if (array.length === idx + 1) {
      return title ? title : startCase(camelCase(array[idx]));
    } else if (value !== '') {
      return startCase(camelCase(value));
    } else {
      return 'Home';
    }
  };

  return (
    <div className="">
      {breadcrumbItems.map((link, idx, array) => {
        const url = array.slice(0, idx + 1).join('/');
        return (
          // If color prop is passed, it assumes it's an ad campaign and will take the use back to the ad lading page
          <SLink key={idx} to={`${url ? `${url}/` : '/'}`} isBlog={isBlog}>
            {getBreadcrumbName(link, array, idx, title)}
          </SLink>
        );
      })}
    </div>
  );
};

Breadcrumbs.propTypes = {
  title: PropTypes.string.isRequired,
  isBlog: PropTypes.bool,
};

export default Breadcrumbs;
